import { Component } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import FindMatches from "@/pages/FindMatches";
import Contact from "@/pages/Contact";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import CreateProfile from "@/pages/CreateProfile";
import MyProfile from "@/pages/MyProfile";
import AdminPanel from "@/pages/AdminPanel";
import AdminLogin from "@/pages/AdminLogin";
import PolicyPage from "@/components/suffa/PolicyPage";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/lib/i18n";
import { AuthProvider } from "@/lib/AuthContext";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: "100vh",
            display: "grid",
            placeItems: "center",
            background: "#FDFBF7",
            color: "#1C1917",
            fontFamily: "sans-serif",
          }}
        >
          Something went wrong. Please refresh the page.
        </div>
      );
    }
    return this.props.children;
  }
}

function App() {
  return (
    <ErrorBoundary>
      <LanguageProvider>
        <AuthProvider>
          <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/find-matches" element={<FindMatches />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/create-profile" element={<CreateProfile />} />
            <Route path="/my-profile" element={<MyProfile />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={<AdminPanel />} />
            <Route path="/terms" element={<PolicyPage policyKey="terms" />} />
            <Route path="/privacy" element={<PolicyPage policyKey="privacy" />} />
            <Route path="/safety-guidelines" element={<PolicyPage policyKey="safety" />} />
            <Route path="/payment-refund" element={<PolicyPage policyKey="payment" />} />
            <Route path="/match-fee" element={<PolicyPage policyKey="matchFee" />} />
            <Route path="/faq" element={<PolicyPage policyKey="faq" />} />
            <Route path="/about" element={<PolicyPage policyKey="about" />} />
          </Routes>
          <Toaster position="bottom-center" />
          </BrowserRouter>
        </AuthProvider>
      </LanguageProvider>
    </ErrorBoundary>
  );
}

export default App;
